import cloneDeep from 'lodash/cloneDeep';
import formatDate from '@/services/general/formatIsoDate';
import {
  panneauxLcUrlPhotoManager,
  panneauxNumeriqueUrlPhotoManager,
  reseauxUrlPhotoManager,
  reseauxPersonnaliseUrlPhotoManager,
} from '@/services/opportunite/opportuniteUrlPhotoManager';

export default function preparationEnvoiBack(opp) {
  const copieOpp = cloneDeep(opp);
  if (copieOpp.data.client.nomCommercial !== undefined) {
    if (copieOpp.data.client.latitude === undefined) copieOpp.data.client.latitude = null;
    if (copieOpp.data.client.longitude === undefined) copieOpp.data.client.longitude = null;
  }
  if (Array.isArray(copieOpp.data.produits.panneauxLc)) {
    copieOpp.data.produits.panneauxLc.forEach((el) => {
      el.extensionOpportunite.date = formatDate(el.extensionOpportunite.date);
      el.extensionOpportunite.dateDisponibilite = formatDate(
        el.extensionOpportunite.dateDisponibilite);
      el.extensionOpportunite.dateFin = formatDate(el.extensionOpportunite.dateFin);
      panneauxLcUrlPhotoManager(el, false);
      if (!el.codeFaces) el.codeFaces = '';
    });
  }
  if (Array.isArray(copieOpp.data.produits.reseauxLc)) {
    copieOpp.data.produits.reseauxLc.forEach((el) => {
      el.extensionOpportunite.date = formatDate(el.extensionOpportunite.date);
      reseauxUrlPhotoManager(el, false);
    });
  }
  if (Array.isArray(copieOpp.data.produits.reseauxPersonnalise)) {
    copieOpp.data.produits.reseauxPersonnalise.forEach((el) => {
      el.dateDebut = formatDate(el.dateDebut);
      el.dateFin = formatDate(el.dateFin);
      reseauxPersonnaliseUrlPhotoManager(el, false);
    });
  }
  if (Array.isArray(copieOpp.data.produits.reseauxTempo)) {
    copieOpp.data.produits.reseauxTempo.forEach((el) => {
      el.dateEtatObtenu = formatDate(el.dateEtatObtenu);
      el.dateEtatSouhaite = formatDate(el.dateEtatSouhaite);
      reseauxUrlPhotoManager(el, false);
    });
  }
  if (Array.isArray(copieOpp.data.produits.panneauxNumeriques)) {
    copieOpp.data.produits.panneauxNumeriques.forEach((el) => {
      panneauxNumeriqueUrlPhotoManager(el, false);
      if (!el.codeFaces) el.codeFaces = '';
    });
  }
  if (Array.isArray(copieOpp.data.produits.reseauxNumeriques)) {
    copieOpp.data.produits.reseauxNumeriques.forEach((el) => {
      reseauxUrlPhotoManager(el, false);
    });
  }
  return copieOpp;
}



// WEBPACK FOOTER //
// ./src/services/opportunite/preparationEnvoiBackOpp.js